@if (carrier?.toLowerCase() === 'ups') {
    <img alt="UPS"
         class="logo ups"
         height="29.75347"
         ngSrc="assets/images/logos/logo_ups.png"
         width="25">
} @else if (carrier?.toLowerCase() === 'fedex') {
    <img alt="FedEx"
         class="logo fedex"
         height="15.02"
         ngSrc="assets/icons/logo-fedex.svg"
         width="50">
}
